const lang = {
    "Kep": "QES",
    "KepNotLinked": "您的合格电子签名尚未绑定账户。请照常登录，我们将为您绑定。",
    "KepNewAccount": "没有账户？注册",
    "KepLinked": "合格电子签名已绑定到账户",
    "KepLinkFailed": "无法绑定合格电子签名。请再次使用该签名登录，我们将为您绑定",
    "KepFile": "密钥文件",
    "ErrorKepLogin": "使用合格电子签名登录失败",
    "EnterWidth": "登录：",
    "Registration": "登记",
    "enter": "进来",
    "EntrWidthEmailOrPhone": "使用电子邮件或电话登录",
    "login": "授权",
    "NoAkkGoReg": "登记",
    "Password": "密码",
    "Name": "姓名",
    "LastName": "姓",
    "Phone": "要注册，请输入您的电话号码",
    "Email": "邮件",
    "RepeatPassword": "重复输入密码",
    "Сancel": "取消",
    "Save": "节省",
    "Language": "语言",
    "ConfirmThisMail": "您的电子邮件已被确认",
    "Saved": "已保存",
    "Error": "错误",
    "FillInAllTheFields": "填写所有字段",
    "Next": "更远",
    "MinPassLength": "最小密码长度 4 个字符",
    "ForgotYourPassword": "忘记密码了吗",
    "RestorePassword": "请设置新密码。",
    "UserMustBeRegistered": "用户必须注册",
    "Confirm": "确认",
    "WrongFormat": "格式错误",
    "WrongPassword": "密码错误",
    "WrongLoginOrPassword": "登录名或密码错误",
    "PhoneAlreadyRegistered": "手机已注册",
    "EmailAlreadyRegistered": "邮件已注册",
    "FillInTheFieldsCorrectly": "正确填写字段",
    "ThisAccountDoesNotExist": "此帐户不存在",
    "LinkIsNotValid": "链接无效",
    "AMessageHasBeenSentToTheSpecifiedLogin": "一条消息已发送到指定的用户名",
    "IncorrectCaptcha": "错误验证码",
    "CaptchaIsNotValid": "验证码不再有效",
    "EnterCaptcha": "输入验证码",
    "EnterSMS": "输入短信验证码",
    "SMSCodeIsNoLongerValid": "短信代码不再有效",
    "SMSCodeIsIncorrect": "短信代码不正确",
    "MailNotVerifiedLinkTimedOut": "邮件未确认，链接已过期",
    "DemoLogin": "演示登录",
    "AreYouSureYouWantToEnterTheDemoForEvaluation": "您确定要进入<b>演示</b>试用吗？",
    "FillInAdditionalInformation": "填写附加信息",
    "ToCompleteRegistration": "完成注册",
    "LinkThirdPartyServices": "链接第三方服务",
    "Complete": "去完成",
    "AccountAlreadyLinked": "帐号已关联",
    "AccountNotRegistered": "帐号未注册",
    "NotMyNumber": "不是我的号码",
    "Back": "后退",
    "numberOfAttemptsToCheckAuth": "登录尝试次数：",
    "InvalidPassNumberOfAttemptsToCheckAuth": "密码错误，登录尝试次数：",
    "TryAgainAfterMinute": "请 2 分钟后重试",
    "Help": "支持",
    "y": "是的",
    "n": "不是",
    "doYouConfirmEmail": "您确定要更改电子邮件吗？",
    "success": "成功地",
    "goToAutorize": "去授权",
    "UserEmailAlreadyExists": "使用此电子邮件的用户已存在",
    "UserPhoneAlreadyExists": "使用此电话号码的用户已存在",
    "TermOfUse": "使用条款",
    "PrivacyPolicy": "隐私政策",
    "accountNotRegistered": "帐号未注册",
    "wantToReg": "你想注册吗？",
    "weSuccessChangeYouEmail": "我们已成功更改您的电子邮件地址",
    "youCanCloseThisWindow": "您可以关闭此窗口",
    "countryConfirm": "国家确认",
    "EmailAlreadyTied": "邮件已链接到另一个帐户",
    "areYourCountry": "这是你的国家吗？",
    "EmergencyEntrance": "舊授權",
    "enterCorrectNumber": "以國際格式輸入號碼",
    "thisPhoneRegister": "此电话号码已在系统中注册",
    "wantUsePhoneForAuth": "您要使用此电话号码登录吗？",
    "ok": "行",
    "regAgree": "通过注册账户，我接受",
    "wantBind": "想要登录并链接服务",
    "bind": "绑定",
    "yoursMailBinded": "您的电子邮件在现有帐户中",
    "wantUsePhoneAndBind": "已经在系统中注册",
    "notGetDataFromApple": "无法从 Apple 接收数据",
    "ErrorAppleLogin": "通过 Apple 授权时出错",
    "ErrorGoogleLogin": "通过 Google 授权时出错",
    "ErrorTelegramLogin": "通过 Telegram 登录时出错",
    "ErrorFacebookLogin": "通过 Facebook 登录时出错",
    "EMailOrPhone": "请输入有效的电话号码或电子邮件地址。",
    "withoutName": "无名字",
    "goToCabinet": "去办公室",
    "Logout": "结束会话",
    "creationDate": "创建日期",
    "preparingCompany1": "我们正在创建您的公司，请给我们一点时间...",
    "preparingCompany2": "我们正在准备一个用于管理商品和服务的界面......",
    "preparingCompany3": "我们正在致力于便捷的财务会计...",
    "preparingCompany4": "我们正在进行最后的设置，几乎准备好了......",
    "companyBlocked": "该公司不活跃",
    "youBlockedInComp": "用户未激活，无法登录",
    "loginTitle": "企业所需的一切都集中在一个地方",
    "loginDescr": "商店、咖啡馆、送货服务、餐厅、仓库、生产或服务的自动化",
    "NoAkkGoRegText": "沒有帳戶？",
    "LoginPlaceholder": "请提供所需信息",
    "loginText": "已有账户？",
    "and": "和",
    "AcceptTheTerms": "请接受隐私政策和使用条款",
    "CountryPhoneFormat": "如果这不是您的国家，请检查您是否以正确的国际格式输入了您的电话号码。",
    "SaveNewPassword": "保存新密码"
}

export default function() {
    return lang;
}